import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import api from "../../services/api";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const DEFAULT_STATUSES = [];

const Statuses = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const isAdmin = user?.profile === "admin";

  const [statuses, setStatuses] = useState([]);
  const [whatsapps, setWhatsapps] = useState([]);
  const [selectedWhatsappId, setSelectedWhatsappId] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState({ id: "", name: "", color: "#64748b" });

  useEffect(() => {
    fetchWhatsapps();
  }, []);

  useEffect(() => {
    fetchStatuses();
  }, [selectedWhatsappId]);

  const fetchWhatsapps = async () => {
    try {
      const { data } = await api.get("/whatsapp");
      setWhatsapps(data || []);
      if (data && data.length > 0) {
        setSelectedWhatsappId(data[0].id.toString());
      }
    } catch (err) {
      toastError(err);
    }
  };

  const getSettingKey = (wappId) => {
    const id = wappId || selectedWhatsappId;
    return id ? `statuses_list_wapp_${id}` : "statuses_list";
  };

  const fetchStatuses = async (wappId) => {
    const targetId = wappId || selectedWhatsappId;
    if (!targetId) return;
    setLoading(true);
    try {
      const { data } = await api.get("/settings");
      const key = `statuses_list_wapp_${targetId}`;
      const settingItem = data.find(s => s.key === key);
      if (settingItem && settingItem.value) {
        try {
          setStatuses(JSON.parse(settingItem.value));
        } catch {
          setStatuses(DEFAULT_STATUSES);
        }
      } else {
        setStatuses(DEFAULT_STATUSES);
        // Persiste automaticamente no banco para garantir que a conexao tenha seus proprios status
        await api.put(`/settings/${key}`, { value: JSON.stringify(DEFAULT_STATUSES) });
      }
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  const handleWhatsappChange = (e) => {
    const newId = e.target.value;
    setSelectedWhatsappId(newId);
    fetchStatuses(newId);
  };

  const handleSaveStatuses = async (newList) => {
    try {
      const key = getSettingKey();
      await api.put(`/settings/${key}`, { value: JSON.stringify(newList) });
      setStatuses(newList);
      toast.success("Etapas de Status atualizadas para esta conexão!");
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenModal = (item = null) => {
    if (item) {
      setSelectedStatus(item);
    } else {
      setSelectedStatus({ id: Date.now().toString(), name: "", color: "#64748b" });
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedStatus({ id: "", name: "", color: "#64748b" });
    setModalOpen(false);
  };

  const handleSubmit = async () => {
    if (!selectedStatus.name.trim()) {
      toast.error("O nome do status é obrigatório!");
      return;
    }

    let updated;
    const exists = statuses.some(s => s.id === selectedStatus.id);
    if (exists) {
      updated = statuses.map(s => s.id === selectedStatus.id ? selectedStatus : s);
    } else {
      updated = [...statuses, selectedStatus];
    }

    await handleSaveStatuses(updated);
    handleCloseModal();
  };

  const handleDelete = async (id) => {
    const updated = statuses.filter(s => s.id !== id);
    await handleSaveStatuses(updated);
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>📊 Status do Cliente por Marca</Title>
        {isAdmin && (
          <MainHeaderButtonsWrapper>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleOpenModal()}
            >
              + Novo Status / Etapa
            </Button>
          </MainHeaderButtonsWrapper>
        )}
      </MainHeader>

      <Paper variant="outlined" style={{ padding: "12px 16px", margin: "8px 8px 12px 8px", backgroundColor: "#f8fafc", display: "flex", alignItems: "center", gap: 16 }}>
        <Typography style={{ fontWeight: "bold", fontSize: "0.95rem", color: "#0f172a" }}>
          📱 Selecionar Marca / Conexão de WhatsApp:
        </Typography>
        <FormControl variant="outlined" size="small" style={{ minWidth: 320, backgroundColor: "#ffffff" }}>
          <Select
            value={selectedWhatsappId}
            onChange={handleWhatsappChange}
            style={{ fontWeight: "bold", color: "#0284c7" }}
          >
            {whatsapps.map(w => (
              <MenuItem key={w.id} value={w.id.toString()}>
                📱 {w.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>

      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">Badges do Status</TableCell>
              <TableCell align="center">Nome do Status</TableCell>
              <TableCell align="center">Cor Hex</TableCell>
              {isAdmin && <TableCell align="center">Ações</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {statuses.map(item => (
              <TableRow key={item.id}>
                <TableCell align="center">
                  <Chip
                    label={item.name}
                    style={{ backgroundColor: item.color || "#64748b", color: "#fff", fontWeight: "bold" }}
                  />
                </TableCell>
                <TableCell align="center">{item.name}</TableCell>
                <TableCell align="center">
                  <span style={{ color: item.color, fontWeight: "bold" }}>{item.color}</span>
                </TableCell>
                {isAdmin && (
                  <TableCell align="center">
                    <IconButton size="small" onClick={() => handleOpenModal(item)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleDelete(item.id)}>
                      <DeleteOutlineIcon />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="xs" fullWidth>
        <DialogTitle>{selectedStatus.id ? "Editar Status" : "Novo Status"}</DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            label="Nome do Status (ex: 💰 COMPROU / AGENDOU)"
            fullWidth
            margin="dense"
            variant="outlined"
            value={selectedStatus.name}
            onChange={(e) => setSelectedStatus({ ...selectedStatus, name: e.target.value })}
          />
          <TextField
            label="Cor do Status"
            fullWidth
            margin="dense"
            variant="outlined"
            type="color"
            style={{ marginTop: 16 }}
            value={selectedStatus.color || "#64748b"}
            onChange={(e) => setSelectedStatus({ ...selectedStatus, color: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary" variant="outlined">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </MainContainer>
  );
};

export default Statuses;
